import React, { useState, useEffect } from 'react';
import '../styles/BuildingPlanScreen.css';
import Logo from '../assets/logo.svg';
import Mantra1 from '../assets/images/Mantra_1.png';
import Mantra2 from '../assets/images/Mantra_2.png';
import Mantra3 from '../assets/images/Mantra_3.png';

const MANTRA_IMAGES = [Mantra1, Mantra2, Mantra3];

const LOADING_MESSAGES = [
  { text: 'Analyzing your training profile...', duration: 1500 },
  { text: 'Building your periodization structure...', duration: 2000 },
  { text: 'Creating macrocycle schedule...', duration: 1800 },
  { text: 'Generating workout templates...', duration: 2000 },
  { text: 'Scheduling your first weeks...', duration: 1500 },
  { text: 'Finalizing your program...', duration: 1200 },
];

function BuildingPlanScreen({ personaName = 'your', onComplete }) {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const [fadeOut, setFadeOut] = useState(false);
  const [mantraImage] = useState(() =>
    MANTRA_IMAGES[Math.floor(Math.random() * MANTRA_IMAGES.length)]
  );

  useEffect(() => {
    const totalDuration = LOADING_MESSAGES.reduce((sum, m) => sum + m.duration, 0);
    let elapsed = 0;

    const progressInterval = setInterval(() => {
      elapsed += 50;
      const newProgress = Math.min((elapsed / totalDuration) * 100, 100);
      setProgress(newProgress);

      let accumulatedTime = 0;
      for (let i = 0; i < LOADING_MESSAGES.length; i++) {
        accumulatedTime += LOADING_MESSAGES[i].duration;
        if (elapsed < accumulatedTime) {
          setCurrentMessageIndex(i);
          break;
        }
      }

      if (elapsed >= totalDuration) {
        clearInterval(progressInterval);
        setFadeOut(true);
        setTimeout(() => {
          if (onComplete) onComplete();
        }, 600);
      }
    }, 50);

    return () => clearInterval(progressInterval);
  }, [onComplete]);

  return (
    <div className={`building-plan-screen ${fadeOut ? 'fade-out' : ''}`}>
      {/* Mantra-style background */}
      <div
        className="building-bg"
        style={{ backgroundImage: `url(${mantraImage})` }}
      />
      <div className="building-overlay" />

      {/* Centered content */}
      <div className="building-content">
        <img src={Logo} alt="Begin Strength" className="building-logo" />

        <h1 className="building-title">
          Building Your {personaName} Program
        </h1>

        <p className="building-message" key={currentMessageIndex}>
          {LOADING_MESSAGES[currentMessageIndex].text}
        </p>

        <div className="building-progress-container">
          <div
            className="building-progress-bar"
            style={{ width: `${progress}%` }}
          />
        </div>

        <p className="building-percentage">{Math.round(progress)}%</p>
      </div>
    </div>
  );
}

export default BuildingPlanScreen;
